<script setup lang="ts">
defineOptions({ inheritAttrs: false });
defineProps<{
  buttonText?: string;
}>();

const emit = defineEmits(["click"]);
</script>
<template>
  <nut-button class="mp-button" v-bind="$attrs" @click.stop="emit('click')">
    <template #default v-if="$slots.default">
      <slot name="default" />
    </template>
    <template #default v-else-if="buttonText">
      {{ buttonText }}
    </template>
    <template #icon v-if="$slots.icon">
      <slot name="icon" />
    </template>
  </nut-button>
</template>
<style lang="scss">
.mp-button.nut-button--square {
  &.nut-button--mini {
    border-radius: 6px !important;
  }

  &.nut-button--small {
    border-radius: 8px !important;
  }

  &.nut-button--normal {
    border-radius: 10px !important;
  }

  &.nut-button--large {
    border-radius: 12px !important;
  }
}
</style>
